import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {AuthActionTypes, Login, LoginComplete, LoginError, Logout, LogoutSuccess} from '../actions/auth.actions';
import {catchError, exhaustMap, map, tap} from 'rxjs/operators';
import {of} from 'rxjs';
import {HttpErrorResponse} from '@angular/common/http';
import {LoginRequest, LoginResponse} from '../models/auth';
import {AuthService} from '../services/auth.service';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';

import * as fromAfbGraphqlApi from '../reducers';
import {StopAirDataPoll} from '../../afb-api/actions/air-data-poll.actions';

@Injectable()
export class AuthEffects {

  @Effect()
  login$ = this.actions$.pipe(
    ofType(AuthActionTypes.Login),
    map((action: Login) => action.payload),
    exhaustMap((loginRequest: LoginRequest) =>
      this.authService.login(loginRequest)
        .pipe(
          map((loginResponse: LoginResponse) => new LoginComplete(loginResponse)),
          catchError((error: HttpErrorResponse) => of(new LoginError({
            errorMessage: this.getLoginErrorMessage(error)
          })))
        )
    )
  );

  @Effect({dispatch: false})
  loginComplete$ = this.actions$.pipe(
    ofType(AuthActionTypes.LoginComplete),
    map((action: LoginComplete) => action.payload),
    map((loginResponse: LoginResponse) => {
      // TODO: Self should be retrieved using API call
      const {accessToken: deletedKey, ...self} = loginResponse;
      localStorage.setItem('access_token', loginResponse.accessToken);
      localStorage.setItem('self', JSON.stringify(self));
    })
  );

  @Effect()
  logout$ = this.actions$.pipe(
    ofType(AuthActionTypes.Logout),
    tap((action: Logout) => {
      localStorage.clear();
      this.state$.dispatch(new StopAirDataPoll());
      this.router.navigate(['/login']);
    }),
    map((action: Logout) => new LogoutSuccess())
  );

  constructor(private actions$: Actions,
              private state$: Store<fromAfbGraphqlApi.State>,
              private router: Router,
              private authService: AuthService) {
  }

  private getLoginErrorMessage(error: HttpErrorResponse): string {
    const errorMap = {
      422: 'Check your email address and password.',
      404: 'Cannot find an account with this email address.'
    };

    return errorMap[error.status] || 'No response from the server. Please try again later.';
  }
}
